module.exports = __webpack_public_path__ + "img/upc.718c8da5.svg";